export default __webpack_public_path__ + "static/media/ourP2.e6f9e48e.png";